import { action, observable } from "mobx";
import Autobind from "autobind-decorator";

@Autobind
class DCMViewModel {
  @observable _metadataUID: string = ""; // 할당된 DICOM 데이터의 Series UID
  @observable _indexOnDataStack: number = 0; // 출력되는 DICOM 영상의 인덱스
  @observable _extension: { [key: string]: [any] | any } = {}; // 추가 옵션 정보
  @observable _defaultFrameIdx: number = 0;
  @observable _isBatchMode: boolean = false;
  @observable _isActiveState: boolean = false;
  @observable _isMPR: boolean = false;
  @observable _isNagative: boolean = false; // 영상에 반전 효과 적용 여부
  @observable _colorBox: string | null = null;
  @observable _showTagOverlay: boolean = false;
  _onInitCallback: Function = () => {};
  @action setDCMViewModel(
    metadataUID: string,
    index: number,
    defaultFrameIdx: number,
    attribute: string,
    value: any,
    isBatchMode: boolean,
    imageOrientation: string = "axial",
    showTagOverlay: boolean = true,
    MPR: boolean = false,
    colorBox: string | null = null,
    onInitCallback: Function = () => {}
  ) {
    this._metadataUID = metadataUID;
    this._indexOnDataStack = index;
    this._extension[attribute] = value;
    this._defaultFrameIdx = defaultFrameIdx;
    this._isBatchMode = isBatchMode;
    this._showTagOverlay = showTagOverlay;
    //this._extension["MPR"] = observable("axial");
    //this._extension["MPR"] = observable.box("axial");
    this._extension["MPR"] = observable.box(imageOrientation);
    this._isMPR = MPR;
    this._colorBox = colorBox;
    this._onInitCallback = onInitCallback;
  }
  set colorBox(colorBox: string | null) {
    this._colorBox = colorBox;
  }
  get colorBox() {
    return this._colorBox;
  }

  set isBatchMode(isBatchMode: boolean) {
    this._isBatchMode = isBatchMode;
  }
  get isBatchMode() {
    return this._isBatchMode;
  }

  set metadataUID(metadataUID: string) {
    this._metadataUID = metadataUID;
  }
  get metadataUID() {
    return this._metadataUID;
  }

  set defaultFrameIdx(frameIdx: number) {
    this._defaultFrameIdx = frameIdx;
  }

  get defaultFrameIdx() {
    return this._defaultFrameIdx;
  }

  set indexOnDataStack(index: number) {
    this._indexOnDataStack = index;
  }
  get indexOnDataStack() {
    return this._indexOnDataStack;
  }

  set isActiveState(isActive: boolean) {
    this._isActiveState = isActive;
  }
  get isActiveState() {
    return this._isActiveState;
  }

  set showTagOverlay(show: boolean) {
    this._showTagOverlay = show;
  }
  get showTagOverlay() {
    return this._showTagOverlay;
  }

  set onInitCallback(initCallback: Function) {
    this._onInitCallback = initCallback;
  }
  get onInitCallback() {
    return this._onInitCallback;
  }
  @action
  setExtension(attribute: string, value: any) {
    if (attribute === "MPR") {
      this._extension[attribute].set(value);
    } else {
      this._extension[attribute] = value;
    }
  }
  getExtension(attribute: string) {
    if (attribute === "MPR") {
      return this._extension[attribute].get();
    } else {
      return this._extension[attribute];
    }
  }

  set isMPR(isMPR: boolean) {
    this._isMPR = isMPR;
  }
  get isMPR() {
    return this._isMPR;
  }

  set isNagative(nagative: boolean) {
    this._isNagative = nagative;
  }
  get isNagative() {
    return this._isNagative;
  }
}

export default DCMViewModel;
